import { registryApi } from '../clients/AxiosClients'

const salvarPlanejamentosDeCronogramas = async (body) => {
	return registryApi.post(
		'v1/cronogramadeordemdeservicoplanejamento/salvar-planejamentos-de-cronogramas',
		body,
	)
}

const buscarPlanejamentosParaGantt = async (cronogramaId) => {
	return registryApi.get(
		`v1/cronogramadeordemdeservicoplanejamento/buscar-planejamentos-para-gantt?cronogramaId=${cronogramaId}`,
	)
}

export { salvarPlanejamentosDeCronogramas, buscarPlanejamentosParaGantt }
